import { navItems } from "../data/catalog.js";

export function normalizePath(pathname) {
  let path = pathname.replace(/\/+$/, "");
  if (path === "") {
    return "/";
  }
  if (path.endsWith(".html")) {
    path = path.slice(0, -5);
  }
  return path;
}

export function Glyph({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 64 64"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      aria-hidden="true"
    >
      <line x1="8" y1="8" x2="8" y2="56" />
      <rect x="18" y="12" width="38" height="10" />
      <rect x="18" y="27" width="38" height="10" fill="currentColor" stroke="none" />
      <rect x="18" y="42" width="38" height="10" />
    </svg>
  );
}

export function SiteHeader({ currentPath }) {
  return (
    <header className="site-header">
      <div className="container site-header__inner">
        <a href="/" className="brand">
          <Glyph className="brand__glyph" />
          <span className="brand__wm">Specification Architecture</span>
        </a>
        <nav className="nav">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={normalizePath(currentPath) === item.href ? "active" : undefined}
            >
              {item.label}
            </a>
          ))}
        </nav>
        <a href="/protocol#agent-skills" className="btn btn--critical">Install skill</a>
      </div>
    </header>
  );
}

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="spec-footer__split">
          <h2 className="site-footer__display">Draw<br />the&nbsp;box.</h2>
          <div style={{ textAlign: "right", maxWidth: 320 }}>
            <span className="lbl">A KeepStraight subproduct</span>
            <div className="spec-footer__note">
              A platform-agnostic specification for good architecture and maintainable code.
              Patterns, anti-patterns, verification methods, and sources.
            </div>
          </div>
        </div>
        <div className="site-footer__cols">
          <div className="site-footer__col">
            <h4>The specification</h4>
            <ul>
              <li><a href="/patterns">Pattern bank</a></li>
              <li><a href="/case-study">Case study</a></li>
              <li><a href="/design-system">Design</a></li>
            </ul>
          </div>
          <div className="site-footer__col">
            <h4>For agents</h4>
            <ul>
              <li><a href="/protocol">MCP surface</a></li>
              <li><a href="/skills/README.md">Skill package</a></li>
              <li><a href="/mcp/resources.json">Resource fixtures</a></li>
              <li><a href="/data/search-index.json">Search index</a></li>
            </ul>
          </div>
          <div className="site-footer__col">
            <h4>Sources</h4>
            <ul>
              <li><a href="https://martinfowler.com/bliki/TestPyramid.html" target="_blank" rel="noreferrer">Fowler test pyramid</a></li>
              <li><a href="https://sre.google/sre-book/service-level-objectives/" target="_blank" rel="noreferrer">Google SRE SLOs</a></li>
              <li><a href="https://modelcontextprotocol.io/specification/2025-11-25" target="_blank" rel="noreferrer">MCP specification</a></li>
            </ul>
          </div>
          <div className="site-footer__col">
            <h4>The lab</h4>
            <ul>
              <li><a href="https://github.com" target="_blank" rel="noreferrer">GitHub</a></li>
              <li><a href="https://join.slack.com" target="_blank" rel="noreferrer">Slack</a></li>
              <li><a href="mailto:hello@keepstraight.org">hello@keepstraight.org</a></li>
            </ul>
          </div>
        </div>
        <div className="site-footer__legal">
          <div>© 2026 KeepStraight Lab · Content CC BY 4.0 · Tooling MIT</div>
          <div>Patterns describe durable engineering outcomes, not framework recipes.</div>
        </div>
      </div>
    </footer>
  );
}
